<template>
  <div class='load when visible' v-observe-visibility="{ callback: showElement,
                               throttle: throttle,
                               once: true }">
    <slot v-if='visible' />
  </div>
</template>

<script setup>
import { ObserveVisibility as vObserveVisibility } from 'vue3-observe-visibility'
const visible = ref(false);
const showElement = (visibility) => {
  visible.value = visibility;
}
const props = defineProps({
  throttle: {
    type: Number,
    default: -400
  },
});
</script>

<style scoped>
  div {
    min-height: 3rem;
    display: block;
    height: fit-content;
    vertical-align: bottom;
  }
</style>
